import {Anrede, SterbefallStatus, VerfuegungArt} from "./enums";

import {Person} from "./person";
import {Bestattung} from './bestattung';
import {Termin} from "./termin";
import {Verstorbener} from "./verstorbener";
import {VerwandtschaftsArt} from './enums';


/**
 * Daten eines Sterbefalls.
 */
export class Sterbefall {

	//Versionsnummer dieses Datenschemas
	schema: string = "0.2";

	//Eindeutige UUID des Sterbefalls
	id: string;

	//Status
	status: SterbefallStatus = SterbefallStatus.Entwurf;

	//Verstorbener
	verstorbener: Verstorbener = new Verstorbener();

	//Veröffentlichung
	sterbebuch: boolean;
	auskunftssperre: boolean;
	zeitung: boolean;

	//Verwandte
	ehepartner: Person = new Person(VerwandtschaftsArt.Ehepartner);
	vater: Person = new Person(VerwandtschaftsArt.Vater, Anrede.Herr);
	mutter: Person = new Person(VerwandtschaftsArt.Mutter, Anrede.Frau);
	verwandte: Person[] = [];

	//Vermögen
	verfuegungArt: VerfuegungArt;
	verfuegungdaten: string;

	//Anmelder, Grabrecht, Kostenträger
	anmelder: Person = new Person();
	grabrecht: Person = new Person();
	kostentraeger: Person = new Person();

	//Bestattung
	bestattung: Bestattung = new Bestattung();

	//Termine
	termine: Termin[] = [];

	//Freitext-Notiz
	notiz: string;


	/**
	 * Gibt den Namen des Verstorbenen zur Anzeige zurück.
	 * "Wenger, Andreas", "Wenger" oder "(Ohne Name)".
	 */
	getVerstorbenerName() : string {
		let v = this.verstorbener;
		if (!v.nachname && !v.vorname)
			return "(Ohne Name)"
		else if (!v.vorname)
			return v.nachname;
		else
			return `${v.nachname}, ${v.vorname}`;
	}

	/**
	 * Gibt Ehepartner, Vater, Mutter und andere Verwandte sowie den
	 * eigens hinterlegten Anmelder, Grabrechtsinhaber und Kostenträger zurück,
	 * sofern hinterlegt.
	 */
	getAngehoerige() : Person[] {
		let ret : Person[] = [];
		if (this.ehepartner.isSet()) ret.push(this.ehepartner);
		if (this.vater.isSet()) ret.push(this.vater);
		if (this.mutter.isSet()) ret.push(this.mutter);
		ret = ret.concat(this.verwandte);
		//spezieller Anmelder, Grabrechtsinhaber und/oder Kostenträger hinterlegt?
		for (let other of [this.anmelder, this.grabrecht, this.kostentraeger])
			if (ret.indexOf(other) == -1 && other.isSet())
				ret.push(other);
		return ret;
	}

	//helper
	isEntwurf() : boolean { return this.status == SterbefallStatus.Entwurf; }
	isGesendet() : boolean { return this.status == SterbefallStatus.Gesendet; }
	isGeloescht() : boolean { return this.status == SterbefallStatus.Geloescht; }

}



// WEBPACK FOOTER //
// ./src/model/sterbefall.ts